module.exports = __webpack_public_path__ + "static/img/banner3.0bcf3d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepageComponent/images/banner3.jpg
// module id = PpJb
// module chunks = 6